/**
 * Маршруты входа и регистрации.
 *
 * Двери разные и на уровне адресов: человек должен видеть, что он заводит
 * кабинет, а не входит в существующий, — и уметь послать ссылку на нужную.
 */
export const AUTH_PATHS = {
  /** Развилка: регистрация или вход. */
  choice: '/auth',
  login: '/login',
  loginVerify: '/verify',
  register: '/register',
  registerVerify: '/register/verify',
  /** Анкета: данные заведения. */
  registerDetails: '/register/details',
} as const;

/**
 * Состояние, с которым один экран передаёт другому уже набранный номер.
 *
 * `notice` — объяснение, почему человек оказался не там, куда шёл. Без него
 * перенос выглядит как сбой навигации.
 */
export interface AuthNavState {
  phone?: string;
  notice?: string;
}
